<script setup>
import { ref, reactive, computed, onMounted, defineComponent, defineExpose } from 'vue'
import { showToast } from 'vant';
import { ElDatePicker } from 'element-plus'
import copy from 'copy-to-clipboard'
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, getUserRoleAPI, getWayListAPI, getPayNapeAPI, createOrderAPI,
  payComfigAPI, getRemarkInfoAPI, getAllPaymentAPI } from '@/util/api'
import fl1 from "@/assets/img/03p/fl1.png"
import fl2 from "@/assets/img/03p/fl2.png"
import fl3 from "@/assets/img/03p/fl3.png"
import fl4 from "@/assets/img/03p/fl4.png"
import fl5 from "@/assets/img/03p/fl5.png"
import fl6 from "@/assets/img/03p/fl6.png"
import fl7 from "@/assets/img/03p/fl7.png"

const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})

const ElementDatePicker = defineComponent(ElDatePicker)

const flArr = ref([
  { flIcon: fl1 },
  { flIcon: fl2 },
  { flIcon: fl3 },
  { flIcon: fl4 },
  { flIcon: fl5 },
  { flIcon: fl6 },
  { flIcon: fl7 },
])
const roleData = ref('')
const showQufu = ref(false)
const activeRole = ref('')
const payWayList = ref('')
const payNapeList = ref('')
const payParams = ref({
  pgid: 59,
  pid: 45,
  gid: 1000796,
  duid: "",
  dsid: "",
  dsname: "",
  drid: "",
  drname: "",
  uid: "",
  uname: "",
  token: "",
  money: "",
  pway: "",
  paycode: '',
  pay_type: "game",
  rechargeid: "", // 充值挡位id
  coin: "", // 挡位游戏币(砖石)
  rebate: "", // 返利百分比(小数)
  accountid: "", // 研发账号id
  roleid: "", // 角色id
})
const showPayWayPop = ref(false)
const configData = ref('')
const payNavIndex = ref('1')
const remarkInfo = ref("")
const recordParams = ref({
  uid: '',
  uname: '',
  pgid: '',
  stime: '',
  etime: '',
  drid: '',
  dsid: ''
})
const showStartTime = ref(false)
const minDate = ref(new Date(2023, 0, 1))
const maxDate = ref(new Date())
const currentDate = ref(['2025', '10', '01'])
const showEndTime = ref(false)
const tableData = ref('')
const timeValue = ref('')
const showQufu2 = ref(false)
const activeRole2 = ref('')

const claimText = ref('')
let codeData = ref([])
const agree = ref(false)
let isWait = ref(false)
const timeOut1 = ref(null)
const count1 = ref(60)


const delayedCode = () => {
  if (count1.value > 0) {
    timeOut1.value = setTimeout(() => {
      count1.value--
      delayedCode()
    }, 1000)
  } else {
    clearTimeout(timeOut1.value)
    isWait.value = false
    count1.value = 60
  }
}

const getUserRole = () => {
  const reqData = {
    pgid: '59',
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token 
  }
  getUserRoleAPI(getReqData(reqData)).then(res => {
    if (res.data.code == 0) {
      roleData.value = res.data.data
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}

const checkRole = (role) => {
  showQufu.value = false
  activeRole.value = role
  console.log('【选择区服】', role);
}

const getWayList = () => {
  getWayListAPI(getReqData({ pgid: 59 })).then(res => {
    if (res.data.code == 0) {
      console.log('【支付列表】', res.data.data);
      payWayList.value = res.data.data
      payWayList.value.forEach((ele) => {
        if (ele.checked == 1) {
          payParams.value.pway = ele.type
          payParams.value.paycode = ele.paycode
        }
      })
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const getPayNape = () => {
  getPayNapeAPI(getReqData({ pgid: 59, pay_type: "game" })).then(res => {
    if (res.data.code == 0) {
      console.log('【档位列表】', res.data.data.list);
      payNapeList.value = res.data.data.list
      payNapeList.value.forEach((ele) => {
        if (ele.checked) {
          payParams.value.money = ele.money;
          payParams.value.rechargeid = ele.productid;
          payParams.value.rebate = ele.rebate;
          payParams.value.coin = ele.coin;
        }
      });
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const checkPayNape = (nape) => {
  payNapeList.value.forEach((ele) => {
    ele.checked = 0
  });
  nape.checked = 1
  payParams.value.money = nape.money;
  payParams.value.rechargeid = nape.productid;
  payParams.value.rebate = nape.rebate;
  payParams.value.coin = nape.coin;
}
const goPay = () => {
  if (!activeRole.value.dsid) {
    showToast({ type: 'fail', message: '서버 선택', className:'toast-fail' })
    return
  }
  console.log('【去选择支付】');
  
  showPayWayPop.value = true
}
const checkPayWay = (pay) => {
  payWayList.value.forEach((ele) => {
    ele.checked = 0
  });
  pay.checked = 1
  console.log('【怕有】', pay);
  payParams.value.pway = pay.type
  payParams.value.paycode = pay.paycode
}
const createOrder = () => {
  payParams.value.uid = userInfo.value.uid
  payParams.value.uname = userInfo.value.uname
  payParams.value.token = userInfo.value.token
  payParams.value.dsid = activeRole.value.dsid
  payParams.value.dsname = activeRole.value.dsname
  payParams.value.drid = activeRole.value.drid
  payParams.value.drname = activeRole.value.drname
  createOrderAPI(getReqData(payParams.value)).then(res => {
    if (res.data.code == 0) {
      console.log('【下单接口】', res.data.data);
      payComfig(payParams.value, res.data.data.moid)
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const payComfig = (data, moid) => {
  let reqData = data
  reqData.moid = moid
  reqData.pdata = ''
  payComfigAPI(getReqData(reqData)).then(res => {
    if (res.data.code == 0) {
      window.location.href = res.data.data.trade
      showPayWayPop.value = false
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const toAppStor = () => {
  window.location.href = configData.value.download[1].value
}
const toGgStor = () => {
  window.location.href = configData.value.download[0].value
}
const getRemarkInfo = () => {
  getRemarkInfoAPI().then(res => {
    if (res.data.code == 0) {
      remarkInfo.value = res.data.data
      console.log('【remarkInfo】', remarkInfo);
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const getAllPayment = () => {
  recordParams.value.uid = userInfo.value.uid
  recordParams.value.uname = userInfo.value.uname
  recordParams.value.pgid = 59
  if (activeRole2.value) {
    recordParams.value.drid = activeRole2.value.drid
    recordParams.value.dsid = activeRole2.value.dsid
  } else {
    recordParams.value.drid = ''
    recordParams.value.dsid = ''
  }
  getAllPaymentAPI(getReqData(recordParams.value)).then(res => {
    if (res.data.code == 0) {
      tableData.value = res.data.data
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const checkRole2 = (role) => {
  showQufu2.value = false
  activeRole2.value = role
  console.log('【选择区服】', role);
}
const changeTime = (ele) => {
  console.log('【ele】', ele);
  recordParams.value.stime = ele[0]
  recordParams.value.etime = ele[1]
}
const goCustomer = () => {
  window.location.href = configData.value.download[2].value
}
const closeAll = () => {
  showQufu.value = false
  showQufu2.value = false
}

const doCopy = (text) => {
  copy(text)
  showToast({ type: 'success', message: 'Link copied successfully, go ahead and share it!', className:'toast-success' })
}

defineExpose({ getUserRole })
onMounted(() => {
  console.log('【userInfo】', userInfo.value);
  if (userInfo.value) {
    getUserRole()
  }
  getWayList()
  getPayNape()
  if (localStorage.getItem('config-record')) {
    configData.value = JSON.parse(localStorage.getItem('config-record'))
  }
  getRemarkInfo()
})
</script>

<template>
  <section class="trade-box" @click="closeAll">
    <section class="page-nav">
      <img v-if="payNavIndex == 1" src="@/assets/img/03p/pay-nav01a.png" alt="" style="height: 0.23rem; padding: 0.14rem 0.54rem;">
      <img v-else src="@/assets/img/03p/pay-nav01.png" alt="" @click="payNavIndex = '1'" style="height: 0.23rem; padding: 0.14rem 0.54rem;">
      <span style="width: 3px; height: 0.25rem; background: rgb(0 0 0 / 10%);"></span>
      <img v-if="payNavIndex == 2" src="@/assets/img/03p/pay-nav02a.png" alt="" style="height: 0.23rem; padding: 0.14rem 0.54rem;">
      <img v-else src="@/assets/img/03p/pay-nav02.png" alt="" @click="payNavIndex = '2'" style="height: 0.23rem; padding: 0.14rem 0.54rem;">
      <span style="width: 3px; height: 0.25rem; background: rgb(0 0 0 / 10%);"></span>
      <img v-if="payNavIndex == 3" src="@/assets/img/03p/pay-nav03a.png" alt="" style="height: 0.23rem; padding: 0.14rem 0.54rem;">
      <img v-else src="@/assets/img/03p/pay-nav03.png" alt="" @click="payNavIndex = '3'" style="height: 0.23rem; padding: 0.14rem 0.54rem;">
    </section>
    <section v-show="payNavIndex == '1'">
      <aside style="width: 8.8rem; display: flex; justify-content: flex-start; align-items: center; margin: 0px 15px;">
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/account-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="width: 2.64rem;">{{ userInfo.uname }}</span>
        </aside>
        <aside style="display: flex; align-items: center; margin: 0.12rem 15px 4px;">
          <img src="@/assets/img/03p/qufu-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <section :class="activeRole ? 'sz-box' : 'sz-box2'" @click.stop="showQufu = true" style="width: 2.64rem; position: relative;">
            {{ activeRole ? activeRole.dsname + '[' + activeRole.dsid + ']'  : '서버 선택' }}
            <section v-show="showQufu" style="position: absolute; left: 0; bottom: -6px; transform: translateY(100%); width: 100%; background: #ffffff; box-shadow: 0px 0px 2px 2px #cdcdcd; border-radius: 10px; padding: 6px 0px;">
              <aside
                v-for="(role, index) in roleData"
                :key="index"
                @click.stop="checkRole(role)"
                class="qufuItem"
              >{{ role.dsname + '[' + role.dsid + ']' }}</aside>
            </section>
          </section>
        </aside>
      </aside>
      <aside style="width: 8.8rem; display: flex; justify-content: flex-start; align-items: center; margin: 0rem 15px 0.2rem;">
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/id-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 1.46rem;">{{ activeRole.drid }}</span>
        </aside>
        <aside style="display: flex; align-items: center; margin-left: 24px;">
          <img src="@/assets/img/03p/name-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 1.46rem;">{{ activeRole.drname }}</span>
        </aside>
      </aside>
      <section style="width: 9.4rem; display: flex; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;">
        <aside v-for="(nape, index) in payNapeList" :key="nape.coin" :class="nape.checked == 1 ? 'prod-item prod-item-act' : 'prod-item prod-item-no'" @click="checkPayNape(nape)">
          <aside class="prod-title text-sys2">{{ nape.desc }}</aside>
          <aside class="prod-zs">
            <img :src="flArr[index].flIcon" alt="" style="width: 1rem; position: absolute; top: 0; right: -0.44rem;">
            <img :src="nape.icon" alt="" style="height: 0.94rem;">
            <span style="color: rgb(0, 104, 226); font-size: 0.2rem;">{{ nape.title }}</span>
          </aside>
          <button class="prod-btn">{{ '₩' + nape.money }}</button>
        </aside>
      </section>
      <aside style="margin: 0.16rem 0rem;display: flex; justify-content: center;">
        <img src="@/assets/img/03p/confirm.png" alt="" @click="goPay" style="width: 3.18rem; height: 0.7rem;">
      </aside>
    </section>
    <section v-show="payNavIndex == '2'">
      <aside style="margin-top: 0.24rem; display: flex; align-items: center;">
        <img src="@/assets/img/03p/account-icon.png" alt="" style="height: 0.27rem; margin-left: 8px;">
        <span class="sz-box" style="width: 1.64rem; margin-left: 12px;">{{ userInfo.uname }}</span>
      </aside>
      <aside class="text-box" v-html="remarkInfo.REMARK"></aside>
      <aside style=" display: flex; justify-content: flex-end; align-items: center; margin-top: 0.24rem;">
        <img src="@/assets/img/04p/help02.png" alt="" @click="goCustomer" style="height: 0.24rem;">
      </aside>
    </section>
    <section v-show="payNavIndex == '3'" style="display: flex; flex-direction: column;">
      <aside style="width: 8.8rem; display: flex; justify-content: flex-start; align-items: center; margin: 0px 15px;">
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/account-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="width: 2.64rem;">{{ userInfo.uname }}</span>
        </aside>
        <aside style="display: flex; align-items: center; margin: 0.12rem 15px 4px;">
          <img src="@/assets/img/03p/qufu-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <section :class="activeRole2 ? 'sz-box' : 'sz-box2'" @click.stop="showQufu2 = true" style="width: 2.64rem; position: relative;">
            {{ activeRole2 ? activeRole2.dsname + '[' + activeRole2.dsid + ']'  : '서버 선택' }}
            <span class="clear-btn" @click.stop="activeRole2 = ''">X</span>
            <section v-show="showQufu2" style="position: absolute; left: 0; bottom: -6px; transform: translateY(100%); width: 100%; background: #ffffff; box-shadow: 0px 0px 2px 2px #cdcdcd; border-radius: 10px; padding: 6px 0px; z-index: 1; max-height: 4.8rem; overflow: hidden; overflow-y: scroll;">
              <aside
                v-for="(role, index) in roleData"
                :key="index"
                @click.stop="checkRole2(role)"
                class="qufuItem"
              >{{ role.dsname + '[' + role.dsid + ']' }}</aside>
            </section>
          </section>
        </aside>
      </aside>
      <aside style="width: 8.8rem; display: flex; justify-content: flex-start; align-items: center; margin: 0rem 15px 0.2rem;">
        <aside style="display: flex; align-items: center;">
          <img src="@/assets/img/03p/id-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 1.46rem;">{{ activeRole2.drid }}</span>
        </aside>
        <aside style="display: flex; align-items: center; margin-left: 24px;">
          <img src="@/assets/img/03p/name-icon.png" alt="" style="height: 18px; margin-right: 4px;">
          <span class="sz-box" style="min-width: 1.46rem;">{{ activeRole2.drname }}</span>
        </aside>
      </aside>
      <aside style="display: flex; align-items: center; margin: 8px 15px 0rem;">
        <span class="text-sys2">총전일시: </span>
        <aside style="display: flex; align-items: center; font-size: 13px; border-radius: 6px; padding: 4px 6px; margin-left: 6px;">
          <!-- <span @click="showStartTime = true" :class="recordParams.stime ? 'time-text' : 'time-text-no'">{{ recordParams.stime ? recordParams.stime : '开始时间' }}</span>- -->
          <!-- <span @click="showEndTime = true" :class="recordParams.etime ? 'time-text' : 'time-text-no'">{{ recordParams.etime ? recordParams.etime : '结束s时间' }}</span> -->
          <ElementDatePicker
            v-model="timeValue"
            type="daterange"
            start-placeholder="시작 시간"
            end-placeholder="종료 시간"
            value-format="YYYY-MM-DD"
            @change="changeTime"
          ></ElementDatePicker>
        </aside>
        <button @click="getAllPayment" class="btn-box">검색</button>
      </aside>
      <span style="color: rgb(90, 131, 208); font-size: 14px; margin: 8px 15px 0rem;">{{ '누적요금: ' + (tableData.SUMMONEY ? tableData.SUMMONEY : 0) }}</span>
      <section style="flex: 1; display: flex; flex-direction: column; align-items: center; margin: 12px 0px 12px; width: 8.9rem;">
        <table v-if="tableData" style="background: rgb(255 255 255 / 60%); width: 8.8rem;">
          <thead style="color: rgb(90, 131, 208); background: rgb(235, 235, 235);">
            <tr>
              <td style="width: 0.56rem;">금액</td>
              <td style="width: 2.38rem;">서버</td><!--区服-->
              <td style="width: 2.6rem;">캐릭터</td><!--角色-->
              <td style="width: 1.2rem;">결제수단</td><!--支付方式-->
              <td style="width: 2rem;">총전일시</td><!--时间-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in tableData.data" :key="index">
              <td>{{ list.SHOWMONEY }}</td>
              <td>{{ list.DRNAME + '[' + list.DSID + ']' }}</td>
              <td>{{ list.DRNAME }}</td>
              <td>{{ list._PWAY }}</td>
              <td>{{ list.ATIME }}</td>
            </tr>
          </tbody>
        </table>
        <span v-else style="color: #999999; font-size: 14px;">해당하는 검색 결과가 없습니다.</span>
      </section>
    </section>
    <section class="mask-box" v-if="showPayWayPop">
      <section class="mask-content">
        <aside style="display: flex; justify-content: flex-end; align-items: center; height: 36px; width: 100%;">
          <aside style="flex: 1; display: flex; justify-content: center; align-items: center;">
            <span style="font-size: 17px; font-weight: bold; color: rgb(0, 104, 226);">결제수단</span>
          </aside>
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="showPayWayPop = false" style="height: 28px; margin-right: 12px;">
        </aside>
        <section style="width: 450px; height: 240px; margin-top: 24px; overflow: hidden; overflow-y: scroll;">
          <aside v-for="(pay, index) in payWayList" :key="index" :class="pay.checked ? 'payItem payItem-act' : 'payItem'" @click="checkPayWay(pay)">
            <img :src="pay.icon" alt="" style="height: 45px;">
            <span style="font-size: 14px; font-weight: bold;">{{ pay.desc }}</span>
          </aside>
        </section>
        <button class="pay-btn" @click="createOrder" style="margin: 16px 0px;">결제하기</button>
      </section>
    </section>
    <aside class="side-right">
      <img src="@/assets/img/01p/xz.png" alt="" style="height: 0.22rem; margin-bottom: 0.1rem;">
      <img v-if="configData" :src="configData.download[4].value" alt="" style="width: 1.36rem; margin-bottom: 0.2rem;">
      <img src="@/assets/img/01p/btn0201.png" alt="" @click="toAppStor" style="height: 0.45rem; margin-bottom: 0.1rem;">
      <img src="@/assets/img/01p/btn0202.png" alt="" @click="toGgStor" style="height: 0.45rem; margin-bottom: 0.1rem;">
      <!-- <img src="@/assets/img/01p/btn0102.png" alt="" style="height: 0.45rem;"> -->
    </aside>
  </section>
</template>

<style scoped>
.trade-box {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url('../../assets/img/03p/bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.page-nav {
  background: rgb(133, 176, 211);
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 9.7rem;
  margin-top: 1rem;
}
.sz-box {
  display: block;
  border: 1px solid rgb(94, 140, 196);
  border-radius: 10px;
  font-size: 15px;
  color: rgb(94, 140, 196);
  padding: 3.5px 12px;
  background: #ffffff;
  height: 30px;
  line-height: 30px;
}
.sz-box2 {
  display: block;
  border: 1px solid rgb(94, 140, 196);
  border-radius: 10px;
  font-size: 15px;
  color: #bcbcbc;
  padding: 3.5px 12px;
  background: #ffffff;
  height: 30px;
  line-height: 30px;
}
.prod-item {
  width: 1.92rem;
  height: 2.58rem;
  background: url('../../assets/img/03p/dw-bac.png') no-repeat;
  border-radius: 0.12rem 0.04rem 0.16rem 0.04rem;
  background-size: 100% 100%;
  margin: 0rem 0.1rem 0.15rem;
  /* padding: 1px 2px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 0px 3px 3px #cdcdcd;
}
.prod-item-no {
  border: 3px solid #ffffff;
}
.prod-item-act {
  border: 3px solid rgb(253, 206, 75);
}
.prod-item .prod-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.4rem;
  width: 100%;
  background: url('../../assets/img/03p/pay-title-bac.png') no-repeat;
  background-size: 100% 100%;
}
.prod-item .prod-zs {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.prod-btn {
  background: url('../../assets/img/03p/pay-btn-bac.png') no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 0.24rem;
  font-weight: bold;
  font-style: italic;
  text-shadow: -1px -1px 0 rgb(0, 34, 77), 1px -1px 0 rgb(0, 34, 77), -1px 1px 0 rgb(0, 34, 77), 1px 1px 0 rgb(0, 34, 77);
  width: 1.64rem;
  height: 0.54rem;
  border: none;
  margin-bottom: 6px;
}
.pay-btn {
  background: url('../../assets/img/03p/pay-btn-bac.png') no-repeat;
  background-size: 100% 100%;
  color: rgb(0, 104, 226);
  font-size: 0.22rem;
  font-weight: bold;
  /* text-shadow: -1px -1px 0 rgb(0, 34, 77), 1px -1px 0 rgb(0, 34, 77), -1px 1px 0 rgb(0, 34, 77), 1px 1px 0 rgb(0, 34, 77); */
  width: 1.64rem;
  height: 0.44rem;
  border: none;
  margin-bottom: 6px;
}
.text-sys2 {
  font-size: 0.2rem;
  /* font-weight: bolder; */
  color: #ffffff;
  text-shadow: -1px -1px 0 rgb(67, 116, 167), 1px -1px 0 rgb(67, 116, 167), -1px 1px 0 rgb(67, 116, 167), 1px 1px 0 rgb(67, 116, 167);
}
.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
.side-right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: url('../../assets/img/01p/side-r-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.16rem 0.12rem 0.32rem;
}
.qufuItem {
  color: rgb(94, 140, 196);
  margin: 0px 8px;
  padding: 2px 6px;
  border-radius: 4px;
  border-bottom: 1px solid #efefef;
  font-size: 13px;
}
.qufuItem:hover {
  background: #efefef;
}
.mask-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 80%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask-content {
  width: 480px;
  height: 360px;
  background: url('../../assets/img/nav/login-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.payItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  border-radius: 8px;
  margin-bottom: 4px;
}
.payItem:hover {
  background: rgb(255 165 0 / 60%);
}
.payItem-act {
  color: rgb(94, 140, 196);
  background: rgb(255 165 0 / 60%);
}
.text-box {
  width: 9.16rem;
  padding: 0.24rem;
  border-radius: 10px;
  background: rgb(255 255 255 / 50%);
  font-size: 0.15rem;
  color: rgb(67, 116, 167);
  margin-top: 24px;
  line-height: 1.5;
  max-height: 5.6rem;
  overflow: hidden;
  overflow-y: scroll;
}
table, thead, td {
  font-size: 14px;
  border: 1px solid rgb(146, 176, 206);
  border-collapse: collapse;
}
table {
  width: 100%;
  border-radius: 8px;
  max-height: 5.2rem;
  overflow-y: auto;
  display: block;
}
tr {
  height: 36px;
}
td {
  text-align: center;
  font-size: 12px;
}
.time-text {
  font-size: 13px;
  color: rgb(67, 116, 167);
  padding: 0px 6px;
}
.time-text-no {
  font-size: 13px;
  color: #cdcdcd;
  padding: 0px 6px;
}
.btn-box {
  background: rgb(29, 115, 180);
  border: none;
  border-radius: 6px;
  padding: 4px 20px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0px 0px 2px 2px #cdcdcd;
}
.clear-btn {
  position: absolute;
  top: 50%;
  right: 6px;
  font-size: 12px;
  transform: translateY(-50%);
  background: #dedede;
  color: #ffffff;
  display: block;
  width: 16px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
}
</style>
<style>
strong {
  font-size: 0.16rem;
  font-weight: bold;
}
p {
  color: red;
  display: contents;
}
</style>
